import { render } from "./SidebarUser.vue?vue&type=template&id=3eb9d42e&scoped=true"
import script from "./SidebarUser.vue?vue&type=script&lang=js"
export * from "./SidebarUser.vue?vue&type=script&lang=js"

import "./SidebarUser.vue?vue&type=style&index=0&id=3eb9d42e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb9d42e"]])

export default __exports__